<script lang="ts">
	import { format } from 'svelte-i18n';
	import { Text, Stack, AdvancedCard, LabelList, AdvancedCardV2 } from '@Shelly/shelly-design-system';
	import DeviceInList from '../../Lists/Devices/DeviceInList.svelte';
	import { capFirstChar } from '../../../helpers/utilities';
	import { load_image_from, real_id } from 'src/helpers/interface_helpers';

	import {
		createMemberSettingsSnapshot,
		createMemberStatusSnapshot,
	} from 'src/stores/device-runtime/status-selectors';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';
	export let actuators;

	$: actuatorIds = actuators?.filter((a) => !a?.deleted).map((a) => a.id) ?? [];
	$: memberStatusStore = createMemberStatusSnapshot(actuatorIds);
	$: memberSettingsStore = createMemberSettingsSnapshot(actuatorIds);
	$: memberStatus = $memberStatusStore;
	$: memberSettings = $memberSettingsStore;

	function deviceIsOnline(actuator) {
		const id = real_id(actuator?.id);
		return memberStatus[id] && memberSettings[id];
	}
</script>

<Text styleType="h2" class="mb-s">
	{capFirstChar($format('type_actuators', { default: 'actuators' }))}
</Text>

<Stack gap="s">
	{#if actuators.length > 0}
		{#each actuators as actuator, _ (actuator)}
			{#if !actuator?.deleted}
				{#if deviceIsOnline(actuator)}
					<DeviceInList device={actuator} type={'group'} />
				{:else if $showNewLayout}
					<AdvancedCardV2
						title={`${actuator?.name} - ${capFirstChar($format('label_offline'))}`}
						avatar={{
							image: load_image_from(actuator.image),
							disabled: true,
						}}
						subtitle={{
							value: $format('device_status_offline', {
								default: 'Device is offline',
							}),
							type: 'disabled',
						}}
					/>
				{:else}
					<AdvancedCard
						title={`${actuator?.name} - ${capFirstChar($format('label_offline'))}`}
						avatar={{
							image: load_image_from(actuator.image),
							disabled: true,
						}}
						subtitle={{
							value: $format('device_status_offline', {
								default: 'Device is offline',
							}),
							type: 'disabled',
						}}
					/>
				{/if}
			{:else if $showNewLayout}
				<AdvancedCardV2
					isCondensed
					title={$format('missing_device_label', { default: 'Missing Device' })}
					avatar={{
						icon: 'text-warning fas fa-warning',
					}}
				>
					<svelte:fragment slot="main">
						<LabelList
							labelList={[{ value: actuator?.id, icon: 'fa-solid fa-microchip' }]}
						/>
					</svelte:fragment>
				</AdvancedCardV2>
			{:else}
				<AdvancedCard
					isCondensed
					title={$format('missing_device_label', { default: 'Missing Device' })}
					avatar={{
						icon: 'text-warning fas fa-warning',
					}}
				>
					<svelte:fragment slot="main">
						<LabelList
							labelList={[{ value: actuator?.id, icon: 'fa-solid fa-microchip' }]}
						/>
					</svelte:fragment>
				</AdvancedCard>
			{/if}
		{/each}
	{/if}
</Stack>
